import React, { useMemo, FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import AppLayout, { LayoutType, TOpenGraphMeta } from '@modules/layout/layout/components/AppLayout';
import AppMainNavbar from '@modules/layout/layout/components/AppMainNavbar';
import AppContent from '@modules/layout/layout/components/AppContent';
import AppLeftNav from '@modules/layout/layout/components/AppLeftNav';
import { cloudAPIPage } from '@modules/layout/features/constants/featureConstants';
import SideBarNavigation from '@modules/ui/shared/components/SideBarNavigation';
import stripMarkdown from '@modules/ui/shared/utils/stripMarkdown';
import { OpenAPIData2Content } from '@modules/utilities/pageBuild/content';
import { TestId } from '@modules/utilities/constants/testConstants';
import AppIAHeading from '@modules/layout/layout/components/AppIAHeading';
import AppHeading from '@modules/layout/layout/components/AppHeading';
import CloudIABanner from '@modules/openCloud/CloudIABanner';
import RoasOpenCloudContent from './RoasOpenCloudContent';

type RoasOpenCloudContainerProps = {
  content: OpenAPIData2Content;
  openGraphMeta: Partial<TOpenGraphMeta>;
};

const RoasOpenCloudContainer: FunctionComponent<
  React.PropsWithChildren<RoasOpenCloudContainerProps>
> = ({ content, openGraphMeta }) => {
  const { translate } = useTranslation();

  const { title, description } = content;

  const metaDescription = useMemo(
    () => (description != null ? stripMarkdown(description) : null),
    [description],
  );

  const { path, titleKey } = cloudAPIPage;

  const breadcrumbsItems = useMemo(
    () => [{ label: translate(`Label.${titleKey}`), path }, { label: title }],
    [translate, path, titleKey, title],
  );

  return (
    <AppLayout
      testid={TestId.RoasOpenCloudContainer}
      pageTitle={title}
      pageMetaDescription={metaDescription}
      openGraphMeta={openGraphMeta}
      type={LayoutType.OpenCloudV2}
      renderBanner={() => (process.env.enableOpenCloudIAV2Pages ? <CloudIABanner /> : undefined)}>
      <AppMainNavbar pageTitle={title} breadcrumbsItems={breadcrumbsItems} />
      <AppHeading />
      <AppIAHeading breadcrumbsItems={breadcrumbsItems} />
      <AppContent>
        <RoasOpenCloudContent content={content} />
      </AppContent>
      <AppLeftNav>
        <SideBarNavigation />
      </AppLeftNav>
    </AppLayout>
  );
};

export default RoasOpenCloudContainer;
